import React from "react";
import { Check, Bell, Users, Gift, ArrowLeft, Sparkles } from "lucide-react";

const WhatsAppIcon = () => (
  <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
  </svg>
);

export default function Obrigado() {
  const whatsappLink = "https://chat.whatsapp.com/CtDejmKxtEsG1JeEXtRxTr?mode=gi_t";

  const groupBenefits = [
    { icon: Bell, title: "Avisos importantes", desc: "Atualizações e novidades em primeira mão." },
    { icon: Users, title: "Suporte direto", desc: "Dúvidas com a equipe e a comunidade." },
    { icon: Gift, title: "Desafios e bônus", desc: "Conteúdos extras e desafios exclusivos." },
  ];

  return (
    <div className="min-h-screen bg-neutral-950 text-white flex items-center justify-center p-4 relative overflow-hidden">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[900px] h-[900px] bg-orange-500/10 blur-[120px] rounded-full" />
        <div className="absolute -bottom-40 right-1/3 w-[700px] h-[700px] bg-purple-500/10 blur-[120px] rounded-full" />
      </div>

      <div className="relative w-full max-w-lg">
        <div className="rounded-2xl border border-neutral-800 bg-neutral-900/60 backdrop-blur p-8 md:p-12 shadow-xl text-center">
          <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-green-500/10 flex items-center justify-center">
            <div className="w-14 h-14 rounded-full bg-green-500/15 flex items-center justify-center">
              <Check className="w-8 h-8 text-green-400" strokeWidth={3} />
            </div>
          </div>

          <div className="flex items-center justify-center gap-2 mb-2">
            <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight">Tudo certo!</h1>
            <span className="text-3xl">🎉</span>
          </div>

          <p className="text-neutral-300 text-lg mb-8">
            Agora entre no grupo para receber avisos, atualizações e suporte.
          </p>

          <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="block mb-8">
            <button
              type="button"
              className="w-full inline-flex items-center justify-center gap-3 rounded-xl bg-[#25D366] hover:bg-[#22c55e] text-white font-extrabold text-lg py-4 transition-transform duration-200 hover:scale-[1.01] active:scale-[0.99]"
            >
              <WhatsAppIcon />
              Entrar no Grupo VIP
            </button>
          </a>

          <div className="space-y-4 mb-8">
            {groupBenefits.map((b, i) => {
              const Icon = b.icon;
              return (
                <div key={i} className="flex items-start gap-4 text-left p-4 rounded-xl bg-neutral-900 border border-neutral-800">
                  <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-orange-500/10 flex items-center justify-center">
                    <Icon className="w-5 h-5 text-orange-400" />
                  </div>
                  <div>
                    <h3 className="font-bold mb-1">{b.title}</h3>
                    <p className="text-sm text-neutral-300">{b.desc}</p>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="flex items-center justify-center gap-2 mb-6 text-neutral-300">
            <Sparkles className="w-4 h-4 text-orange-400" />
            <span className="text-sm">Seja bem-vindo(a) à comunidade!</span>
            <Sparkles className="w-4 h-4 text-orange-400" />
          </div>

          <button
            type="button"
            className="inline-flex items-center justify-center gap-2 text-neutral-300 hover:text-white rounded-xl px-4 py-3 hover:bg-neutral-800/60 transition"
            onClick={() => window.history.back()}
          >
            <ArrowLeft className="w-4 h-4" />
            Voltar
          </button>
        </div>

        <p className="text-center text-xs text-neutral-500 mt-6">
          Você receberá também um email com os acessos e instruções.
        </p>
      </div>
    </div>
  );
}
